//Importing modules
import React, { useState } from 'react';
import { makeStyles} from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Checkbox from '@material-ui/core/Checkbox';
import {getTableRowClass} from "../../../utils/utils";



//Defining CSS for List Contents Table
const useStyles = makeStyles((theme) => ({
  tableStyle: {
    border: "none",
    boxShadow: "none",
  },
  blueText: {
    fontFamily: "Open Sans",
    fontWeight: "600",
    color: "#0b1f82"
},
  tableText: {
    fontFamily: "Open Sans",
    fontSize: "12px",
    lineHeight: "16px",
    textAlign: "center",
    margin: "10px",
    padding: "10px",
  },
  tableHeader: {
    textAlign: "center",
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: "normal",
    color: '#6F6F6F',
    fontSize: "14px",
    lineHeight: "19px",
    padding: "6px",
  }
}));


function SharedListPermissionTable(props) {
  //Starting predefined styles to be used on table
  const classes = useStyles();

  //Getting data from props
  let { sharedListPermissions } = props
  let { setSharedListPermissions } = props

  const [allCanRead, setAllCanRead] = useState(
    () => sharedListPermissions.every(item => !item.edit_can_read || item.can_read)
  );
  const [allCanWrite, setAllCanWrite] = useState(
    () => sharedListPermissions.every(item => !item.edit_can_write || item.can_write)
  );

  const handleToggleCanRead = (event, index) => {
      const isChecked = event.target.checked;
      let newListContentsState = [...sharedListPermissions];

      if (index === -1) {
          newListContentsState = newListContentsState.map(item => 
              item.edit_can_read 
                ? { ...item, can_read: isChecked } 
                : item
          );
          setAllCanRead(isChecked);
      } else {
          newListContentsState[index].can_read = isChecked;
          const allAreChecked = newListContentsState.every(item => !item.edit_can_read || item.can_read);
          setAllCanRead(allAreChecked);
      }
      
      setSharedListPermissions(newListContentsState);
  }


  const handleToggleCanWrite = (event, index) => {
    const isChecked = event.target.checked;
    let newListContentsState = [...sharedListPermissions];

    if (index === -1) {
        newListContentsState = newListContentsState.map(item => 
            item.edit_can_write
              ? { ...item, can_write: isChecked }
              : item 
        );
        setAllCanWrite(isChecked);
    } else {
        newListContentsState[index].can_write = isChecked;
        const allAreChecked = newListContentsState.every(item => !item.edit_can_write || item.can_write);
        setAllCanWrite(allAreChecked);
    }
    
    setSharedListPermissions(newListContentsState);
}

  const anyCanRead = sharedListPermissions.some(item => item.edit_can_read);
  const anyCanWrite = sharedListPermissions.some(item => item.edit_can_write);


  //Rendering Table
  return (
    <Paper className={classes.tableStyle}>
      <Table style={{ padding: "8px" }}>
        <TableHead>
            <TableRow>
                <TableCell className={classes.tableHeader}>
                  Nome do Cliente
                </TableCell>
                <TableCell className={classes.tableHeader}>
                  Permissão de Leitura
                </TableCell>
                <TableCell className={classes.tableHeader}>
                  Permissão de Escrita
                </TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
            <TableRow
                key='all_companies'
                className={getTableRowClass(1)}
                > 
                    <TableCell className={[classes.tableText, "breakWord"].join(" ")}>
                      Todas
                    </TableCell>
                    <TableCell className={[classes.tableText, "breakWord"].join(" ")}>
                        <Checkbox
                            checked={allCanRead}
                            onChange={(e) => handleToggleCanRead(e, -1)}
                            disabled={!anyCanRead}
                            color="primary"
                        />
                    </TableCell>
                    <TableCell className={[classes.tableText, "breakWord"].join(" ")}>
                        <Checkbox
                            checked={allCanWrite}
                            onChange={(e) => handleToggleCanWrite(e, -1)}
                            disabled={!anyCanWrite}
                            color="primary"
                        />
                    </TableCell>

            </TableRow>
            {sharedListPermissions.map((rowData,index) => (
                <TableRow
                key={index}
                className={getTableRowClass(index)}
                > 
                    <TableCell className={[classes.tableText, "breakWord"].join(" ")}>
                      {rowData.company_name}
                    </TableCell>
                    <TableCell className={[classes.tableText, "breakWord"].join(" ")}>
                        <Checkbox
                            checked={rowData.can_read}
                            onChange={(e) => handleToggleCanRead(e,index)}
                            disabled={!rowData.edit_can_read}
                            color="primary"
                        />
                    </TableCell>
                    <TableCell className={[classes.tableText, "breakWord"].join(" ")}>
                        <Checkbox
                            checked={rowData.can_write}
                            onChange={(e) => handleToggleCanWrite(e,index)}
                            disabled={!rowData.edit_can_write}
                            color="primary"
                        />
                    </TableCell>

                </TableRow>
            ))}
        </TableBody>
      </Table>
    </Paper>
    
  );
}


export default SharedListPermissionTable;
